const apiUrl = process.env.REACT_APP_API_URL;

export const fetchLeaderboard = async () => {
  try {
    const response = await fetch(`${apiUrl}/leaderboard`, {
      method: "GET", // or "POST" if your route expects that
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch leaderboard");
    }

    return { success: true, data: data.data };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

